export default __webpack_public_path__ + "static/media/Neophyte's Leggings of Supreme Decree.48dbe20a.jpg";